import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const DrawerLayout = ({
  children,
  modifier = '',
  back = true,
  productName,
  showProductName = true,
}) => {
  const history = useHistory();
  const location = useLocation();
  const { pathname } = location;
  const experience = useSelector((state) => state.experience);

  return (
    <div className={`experience-booking ${modifier}`}>
      <div
        className={classnames({
          'experience-booking__header': pathname !== '/' || back,
          'p-4': showProductName,
        })}
      >
        {showProductName && <h3>{productName || experience.product_name}</h3>}
        {back && (
          <div
            role="button"
            className="mt-3 fw-bold"
            onClick={() => history.push('/')}
          >
            <i className="fa fa-chevron-left mt-1 me-2" aria-hidden="true" />
            Back
          </div>
        )}
      </div>
      <div className="experience-booking__content px-4">{children}</div>
    </div>
  );
};

DrawerLayout.propTypes = {
  children: PropTypes.node.isRequired,
  back: PropTypes.bool,
  modifier: PropTypes.string,
  productName: PropTypes.string,
  showProductName: PropTypes.bool,
};

export default DrawerLayout;
